module.exports = __webpack_public_path__ + "static/media/wizualizacja-125.1e13643d.png";